import { gql } from '@/store/helpers/axios.js'
import router from '@/router/index.js'

export default {
  async LOGIN ({ commit }, formData) {
    const { email, password } = formData

    const query = `mutation ($input: UserLoginInput!) {
      userLogin(input: $input) {
        email
        fullname
        technischerKontakt
        requiresIdentificationMobileNr
        requiresTwoFactor
        smsSenderResult
        isOrganisationAccount
        isOrganisationAdmin
      }
    }`

    const variables = {
      input: {
        email,
        password
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      const {
        requiresTwoFactor,
        requiresIdentificationMobileNr,
        smsSenderResult
      } = data.data.userLogin

      commit('SET_SMS_SENDER_RESULT', smsSenderResult)

      if (requiresIdentificationMobileNr) {
        commit('SET_IS_AUTHCODE_PAGE_VISIBLE', true)
        router.push({ name: 'authPhoneNumber' }).catch(() => {})
      } else if (requiresTwoFactor) {
        // Redirect to page where the user has to fill in the SMSCode
        commit('SET_IS_AUTHCODE_PAGE_VISIBLE', true)
        router.push({ name: 'authCode' }).catch(() => {})
      } else {
        // Redirect to Memberarea
        commit('SET_IS_AUTHCODE_PAGE_VISIBLE', false)
        commit('SET_IS_LOGGED_IN', true)
        commit('SET_CURRENT_USER', data.data.userLogin)
        router.push({ name: 'uebersicht' }).catch(() => {})
      }
    }

    return data
  },
  async CHANGE_MOBILE_NUMBER ({ commit }, formData) {
    const { newNumber } = formData

    const query = `mutation userChangeMobileNr ($input: UserChangeIdentificationNumberInput!) {
      userChangeIdentificationNumber (input: $input) {
        ok
      }
    }`

    const variables = {
      input: {
        newNumber
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async RESEND_AUTH_CODE ({ commit }) {
    const query = `mutation userSend2FACode {
      userSend2FACode {
        smsSenderResult
        ok
      }
    }`

    const { data } = await gql({ query })

    if (!data.errors) {
      const { smsSenderResult } = data.data.userSend2FACode
      commit('SET_SMS_SENDER_RESULT', smsSenderResult)
    }

    return data
  },
  async VALIDATE_AUTH_CODE ({ commit }, formData) {
    const { code, rememberDevice } = formData

    const query = `mutation validateUser2FACode ($input: UserLogin2FAInput!) {
      validateUser2FACode (input: $input) {
        email
        fullname
        technischerKontakt
        isOrganisationAccount
        isOrganisationAdmin
      }
    }`

    const variables = {
      input: {
        code,
        rememberDevice
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_CURRENT_USER', data.data.validateUser2FACode)
      commit('SET_IS_LOGGED_IN', true)
      commit('SET_IS_AUTHCODE_PAGE_VISIBLE', false)
    }

    return data
  },
  async REGISTER ({ state }, formData) {
    const {
      email,
      password,
      identificationMobileNr,
      userProfile: {
        anrede,
        firma,
        zusatz,
        vorname,
        name,
        strasse,
        hausNr,
        plz,
        ort,
        land,
        telefon,
        technischerKontakt
      }
    } = formData

    const query = `mutation ($input: UserRegisterInput!) {
      userRegister(input: $input) {
        userId
      }
    }`

    const variables = {
      input: {
        email,
        password,
        identificationMobileNr,
        userProfile: {
          anrede,
          firma,
          zusatz,
          vorname,
          name,
          strasse,
          hausNr,
          plz,
          ort,
          land: `${land}`,
          telefon,
          technischerKontakt
        }
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async FORGOT_PASSWORD ({ state }, formData) {
    const { email } = formData

    const query = `mutation userPasswordRecovery($input: UserPasswordRecoveryInput!) {
      userPasswordRecovery(input: $input) {
        ok
      }
    }`

    const variables = {
      input: {
        email
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async CHECK_PASSWORD_TOKEN ({ state }, token) {
    const query = `query userPasswordTokenIsValid($input: UserPasswordChangeTokenInput!) {
      userPasswordTokenIsValid(input: $input) {
        ok
      }
    }`

    const variables = {
      input: {
        token
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async RESET_PASSWORD ({ state }, formData) {
    const { token, newPassword } = formData

    const query = `mutation userPasswordUpdateByToken($input: UserPasswordChangeByTokenInput!) {
      userPasswordUpdateByToken(input: $input) {
        ok
      }
    }`

    const variables = {
      input: {
        token,
        newPassword
      }
    }

    const { data } = await gql({ query, variables })

    return data
  },
  async LOGOUT ({ commit }, type) {
    commit('SET_CURRENT_USER', {})
    commit('SET_IS_LOGGED_IN', false)
    router.push({ path: '/' }).catch(() => {})
  }
}
